import type { KnowledgeBase } from "@repo/app-types/entities/knowledgeBase";
import { EditableText } from "@repo/ui/Inputs/editableText";
import type { FC } from "react";
import { useUpdateKnowledgeBaseMutation } from "../../../api/entities/knowledgeBase.js";
import { useAppDispatch } from "../../../hooks/hook.js";
import {
  NotificationType,
  showNotification,
} from "../../notificationsOverlay/notificationsSlice.js";

interface KnowledgeBaseNameEditorProps {
  knowledgeBase: Pick<KnowledgeBase, "id" | "name">;
}

export const KnowledgeBaseNameEditor: FC<KnowledgeBaseNameEditorProps> = (
  props,
) => {
  const { knowledgeBase } = props;
  const dispatch = useAppDispatch();
  const [updateKnowledgeBase] = useUpdateKnowledgeBaseMutation();

  const handleSave = async (name: string) => {
    try {
      await updateKnowledgeBase({
        id: knowledgeBase.id,
        data: { name },
      }).unwrap();

      showNotification(dispatch, {
        id: `kb-name-updated-${Date.now()}`,
        primaryMessage: "Knowledge base name updated successfully",
        type: NotificationType.SUCCESS,
      });
    } catch (err: any) {
      showNotification(dispatch, {
        id: `kb-name-update-error-${Date.now()}`,
        primaryMessage: `Failed to update name: ${err.data?.error || err.message || "Unknown error"}`,
        type: NotificationType.FAILURE,
      });
      throw err;
    }
  };

  return (
    <EditableText
      accessibleLabel="Knowledge base name"
      editAccessibleLabel="Edit knowledge base name"
      inputClassName="h-7 py-0 text-xl leading-7 font-semibold"
      isRequired
      maxLength={100}
      onSave={handleSave}
      value={knowledgeBase.name}
    />
  );
};
